var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    "data-name": "Group 2752",
    transform: "translate(9.33 14.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(-9.33 -14.532)",
    fill: "none",
    stroke: "#ffa741",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chef",
    transform: "translate(-4.706 -9.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M107.109,213.554a.221.221,0,1,0-.443,0,3.108,3.108,0,0,0,.714,1.468.221.221,0,0,0,.342-.281A2.682,2.682,0,0,1,107.109,213.554Z",
    transform: "translate(-104.453 -208.908)",
    fill: "#f59637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M310.222,213.333a.221.221,0,0,0-.221.221,2.692,2.692,0,0,1-.614,1.187.221.221,0,0,0,.342.281,3.108,3.108,0,0,0,.714-1.468A.221.221,0,0,0,310.222,213.333Z",
    transform: "translate(-302.92 -208.908)",
    fill: "#f59637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M224.221,213.333a.221.221,0,0,0-.221.221v1.328a.221.221,0,0,0,.443,0v-1.328A.221.221,0,0,0,224.221,213.333Z",
    transform: "translate(-219.353 -208.908)",
    fill: "#f59637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M7.3.885a2.318,2.318,0,0,0-.42.045,2.647,2.647,0,0,0-4.028,0,2.32,2.32,0,0,0-.42-.045,2.433,2.433,0,0,0-1.1,4.6l0,3.344a.9.9,0,0,0,.9.9H7.505a.9.9,0,0,0,.9-.9V5.485A2.433,2.433,0,0,0,7.3.885Zm.664,7.948a.461.461,0,0,1-.46.46H2.231a.46.46,0,0,1-.46-.461V7.966H7.966ZM8.1,5.14a.2.2,0,0,0-.033.017.221.221,0,0,0-.1.155.214.214,0,0,0,0,.037V7.523H1.773l0-2.17a.228.228,0,0,0,0-.036.222.222,0,0,0-.035-.092.219.219,0,0,0-.066-.064.232.232,0,0,0-.035-.018,1.991,1.991,0,0,1,.8-3.815c.043,0,.088.005.133.009a2.636,2.636,0,0,0-.354,1.319.221.221,0,1,0,.443,0,2.213,2.213,0,1,1,4.425,0,.221.221,0,0,0,.443,0,2.636,2.636,0,0,0-.354-1.319c.044,0,.09-.009.133-.009A1.99,1.99,0,0,1,8.1,5.14Z",
    fill: "#f59637"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrder);
export default __webpack_public_path__ + "static/media/new-order.0386d2acdeb0f87a74b913cc671b281f.svg";
export { ForwardRef as ReactComponent };